import React from "react";
import { FormattedMessage } from "react-intl";
import "./home-signup.scss";

import { Text, Icon, Button } from "@ui-kit";

const HomeSignup = ({ viewModalSignup }) => {
  return (
    <div className="home-sign__container">
      <div className="main__container home-sign__content d-flex">
        <div className="home-sign_img">
          <Icon src="/images/banner_contacts.png" />
        </div>
        <div className="home-sign__wrapper">
          <Text as="h2">
            <FormattedMessage
              id="home-sign.title"
              defaultMessage="Join KeyHunter today!"
            />
          </Text>
          <Text as="h4">
            <FormattedMessage
              id="home-sign.description"
              defaultMessage="Start increasing your stock sales in a few clicks"
            />
          </Text>
          <Button onClick={viewModalSignup}>
            <FormattedMessage id="home-sign.button" defaultMessage="Register" />
          </Button>
          <Text as="h4" className="info-bottom">
            <FormattedMessage
              id="home-sign.info"
              defaultMessage="Registration takes no more than 2 minutes. Immediately after logging in, you will be able to test the functionality and evaluate the result"
            />
          </Text>
        </div>
      </div>
    </div>
  );
};

export default HomeSignup;
